var map = {
	"./de.json": [
		2054,
		78
	],
	"./de_CH.json": [
		2055,
		79
	],
	"./de_DE.json": [
		2056,
		80
	],
	"./en.json": [
		718
	],
	"./en_CA.json": [
		2057,
		2
	],
	"./en_CH.json": [
		2058,
		6
	],
	"./en_GB.json": [
		2059,
		8
	],
	"./en_ZA.json": [
		2009,
		3
	],
	"./fr.json": [
		2060,
		81
	],
	"./fr_CA.json": [
		2061,
		15
	],
	"./fr_CH.json": [
		2062,
		2
	],
	"./it.json": [
		2063,
		82
	],
	"./it_CH.json": [
		2064,
		2
	],
	"./no_filename.json": [
		2010,
		3
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 857;
module.exports = webpackAsyncContext;